import React from 'react'
import { useGenericRequestHandler } from '../../../handlers/useGenericRequestHandler'
import { getGodModeOptions } from 'web/src/shared/Utils'

export const useAccountListUsersMutation = () => {
  return useGenericRequestHandler({
    route: 't/listUsers',
    method: 'POST',
    options: {
      json: Object.assign({}, getGodModeOptions())
    }
  })
}
